export const getDisplayPayload = sets => {
  return sets?.map((item, index) => ({
    id: item.id,
    position: index,
  }))
}
